/**
 * Groups Module
 *
 */

angular
  .module('groups', ['ngResource'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.groups.all(), {controller: 'GroupCtrl', templateUrl: '/r/static/templates/groups/all.html'})
      .when(CONFIG.url.groups.add(), {controller: 'GroupEditCtrl', templateUrl: '/r/static/templates/groups/edit.html'})
      .when(CONFIG.url.groups.edit(), {
        controller: 'GroupEditCtrl',
        templateUrl: '/r/static/templates/groups/edit.html',
      })
  }])
  .factory('Group', ['$resource', function ($resource) {
    var Group = $resource(
      CONFIG.api('groups'),
      {},
      {
        reorder: {method: 'POST', isArray: false, params: {id: 'reorder'}},
        request_group_mail_access: {method: 'POST', isArray: false, params: {id: 'request_group_mail_access'}},
      },
    )
    return Group
  }])

/* Controllers */

angular.module('groups').controller('GroupCtrl', ['$scope', '$rootScope', 'Group', '$location', '$compile', function ($scope, $rootScope, Group, $location, $compile) {
  a4.checkStrongholdNotification($rootScope, $scope, $location, $compile)

  $scope.utils.setPageTitle(_('breadcrumb_member_groups'))
  $scope.utils.setPageID('members')
  $scope.sending_request = false

  $scope.groups = Group.query(
    {id: 'all', get_details: true, get_everyone_group: true},
    function () {
      a4.loaded($scope)
    },
    a4.restErrorFactory($scope),
  )

  // FB:121234 (also in fields.js)
  $('body').css('overflow-y', 'inherit')

  $scope.request_group_mail_access = function () {
    if (D4GLOBALS.Grants.OptinetAdmin) {
      alert('Pyyntöä ei voi lähettää admin-kirjautuneena.')
      return
    }
    $scope.sending_request = true
    Group.request_group_mail_access(
      {email: $rootScope.session.user.email},
      // success handler
      function () {
        alert(_('groups_request_sent_success'))
        $scope.sending_request = false
        $('.modal').modal('hide')
      },
      // error handler
      function (data) {
        a4.restErrorFactory($scope)(data)
        alert(_('groups_request_sent_error'))
        $scope.sending_request = false
        $('.modal').modal('hide')
      },
    )
  }

  // Mostly duplicated from field controller
  var _get_order = function () {
    return $.map(
      $.grep($scope.groups, function (e) {
        return e.id
      }),
      function (e) {
        return e.id
      },
    )
  }
  var old_order

  $scope.sortableOptions = {
    cursor: 'move',
    containment: '.page-content',
    items: '.custom',
    handle: '.handle',
    helper: function (e, tr) {
      var $originals = tr.children()
      var $helper = tr.clone()
      $helper.children().each(function (index) {
        // Set helper cell sizes to match the original sizes
        $(this).width($originals.eq(index).width() + 16)
      })
      $helper.addClass('sort-row')
      return $helper
    },
    start: function (e, ui) {
      old_order = JSON.stringify(_get_order())
    },
    stop: function (e, ui) {
      var o = _get_order()
      if (JSON.stringify(o) === old_order) {
        return
      }

      //TODO show loader

      Group.reorder(
        {order: o},
        // success handler
        function (data) {
          $scope.notify.instant($rootScope, _('HTML_notification_group_order_saved'))
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    },
  }
}])

angular.module('groups').controller('GroupEditCtrl', ['$scope', '$location', '$routeParams', 'Group', function ($scope, $location, $routeParams, Group) {
  $scope.utils.setPageID('members')

  // If we are editing then get the Field, else create empty one
  if ($routeParams.id) {
    $scope.utils.setPageTitle(_('group_edit_group'))
    Group.get(
      {id: $routeParams.id},
      function (group) {
        $scope.group = group
        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )
  } else {
    $scope.utils.setPageTitle(_('group_add_new_group'))
    $scope.group = new Group()
    $scope.group.allowed_senders = 'GroupMembers'
    a4.loaded($scope)
  }

  $scope.save = a4.saveFactory($scope, function () {
    $scope.group.$save(
      {id: $scope.group.id},
      // success handler
      function () {
        if ($routeParams.id) {
          $scope.notify.set($scope, _('HTML_notification_group_edited'))
        } else {
          $scope.notify.set($scope, _('HTML_notification_group_added'))
        }
        $location.path(CONFIG.url.groups.all())
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  })

  $scope.cancel = function () {
    $location.path(CONFIG.url.groups.all())
  }

  $scope['delete'] = function () {
    if (confirm(_('js_group_delete_confirm'))) {
      $scope.group.$delete(
        {id: $scope.group.id},
        // success handler
        function () {
          $scope.notify.set($scope, _('HTML_notification_group_deleted'))
          $location.path(CONFIG.url.groups.all())
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }
  }
}])
